import { CommandBar, Dropdown, IBreadcrumbStyles, Icon, Label, Pivot, Text } from '@fluentui/react';

/*
 * Styles for Portal Management Header
 */

export const LoadingContainer = styled.div`
  display: flex;
  height: 288px;
  justify-content: center;
  background: #f2f9ff;
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  background: #f2f9ff;
  flex: 0 1 auto;
  overflow-x: hidden;
  overflow-y: auto;
  min-height: 60px;
  max-height: 50vh;
`;

export const portalManagementStyles: Partial<IBreadcrumbStyles> = {
  itemLink: {
    fontSize: '14px',
    color: '#0064BF',
    fontWeight: 400,
  },
  item: {
    fontSize: '14px',
    color: '#171717',
    fontWeight: 600,
  },
  chevron: {
    color: '##646464',
  },
  root: {
    paddingLeft: '20px',
  },
};

export const DetailsContainer = styled.div`
  display: flex;
  padding-top: clamp(8px, 3vw, 44px);
  padding-left: clamp(24px, 8vw, 100px);
  padding-right: clamp(24px, 8vw, 100px);
  flex-direction: column;

  @media (max-width: 1024px) {
    padding-top: 8px;
    padding-left: 24px;
    padding-right: 24px;
  }
`;

export const PortalManagementTitleText = styled(Text)`
  display: flex;
  background: #f2f9ff;
  font-weight: 800;
  font-size: 26px;
  line-height: 32px;
  padding-bottom: 12px;

  @media (max-width: 1024px) {
    font-size: 18px;
    line-height: 24px;
    padding-bottom: 6px;
  }
`;

export const PortalManagementDetails = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  column-gap: 70px;
  row-gap: 20px;
  padding-bottom: 24px;
  flex-wrap: wrap;

  @media (max-width: 1024px) {
    column-gap: 24px;
    row-gap: 12px;
    padding-bottom: 12px;
  }
`;

export const PortalMetaDataDetails = styled.tr`
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  column-gap: 70px;
  row-gap: 20px;
  padding-bottom: 16px;
  flex-wrap: wrap;

  @media (max-width: 1024px) {
    column-gap: 24px;
    row-gap: 8px;
    padding-bottom: 8px;
  }
`;

export const TypeValueContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Type = styled(Text)`
  color: #646464;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;

export const Value = styled(Text)`
  color: #171717;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
`;

/*
 * Styles for Portal Management Page
 */

export const PortalManagementFilterDiv = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  column-gap: 1%;
  align-items: center;
  padding: 1%;
  flex-wrap: wrap;
  row-gap: 8px;
`;

export const ButtonsTableSection = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: -6px;
  background: #ffffff;
  padding-left: 100px;
  padding-right: 100px;
  flex: 1 1 0;
  min-height: 0;
  overflow: hidden;
  max-width: calc(100vw - 48px);
  box-sizing: border-box;

  @media (max-width: 1024px) {
    padding-left: 24px;
    padding-right: 24px;
    max-width: 100vw;
  }
`;

export const HorizontalScrollWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
  overflow-y: visible;
  scrollbar-gutter: stable;
  padding: 0;
  box-sizing: border-box;
`;

export const DataOwnerTableContentWrapper = styled.div`
  min-width: 1120px;
  width: max-content;
`;

export const EoProtectedIcon = styled(Icon)`
  font-size: 14px;
  color: #605e5c;
`;

export const DialogTitleLabel = styled(Label)`
  font-size: 16px;
`;

export const DialogBodyText = styled(Text)`
  font-size: 12px;
  padding-top: 15px;
`;

export const DropdownStyled = styled(Dropdown)`
  width: 120px;
`;

export const PortalManagementPivot = styled(Pivot)`
  display: flex;
  padding-left: 100px;
  margin-left: -8px;
  background: #f2f9ff;
  flex-shrink: 0;

  @media (max-width: 1024px) {
    padding-left: 16px;
    margin-left: 0;
  }
`;

export const PortalManagementCommandBar = styled(CommandBar)`
  display: flex;
  padding-top: 30px;
  padding-bottom: 8px;
  margin-left: -32px;
  column-gap: 30px;
`;

export const DraftStatus = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 130px;
  height: 24px;
  left: calc(50% - 130px / 2 + 667.73px);
  top: calc(50% - 24px / 2 - 192px);
  border-radius: 2px;
  background: #0078d4;
  font-size: 12px;
  font-weight: 600;
  color: #ffffff;
`;

export const StaleStatus = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 130px;
  height: 24px;
  left: calc(50% - 130px / 2 + 667.73px);
  top: calc(50% - 24px / 2 - 192px);
  border-radius: 2px;
  background:  #8a8886;
  font-size: 12px;
  font-weight: 600;
  color: #ffffff;
`;

export const SubmittedStatus = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 130px;
  height: 24px;
  left: calc(50% - 130px / 2 + 667.73px);
  top: calc(50% - 24px / 2 - 192px);
  border-radius: 2px;
  background: #fcb72b; // orange
  font-size: 12px;
  font-weight: 600;
  color: #323130; // black
`;

export const RejectedStatus = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 130px;
  height: 24px;
  left: calc(50% - 130px / 2 + 667.73px);
  top: calc(50% - 24px / 2 - 192px);
  border-radius: 2px;
  background: #ff6666; // red
  font-size: 12px;
  font-weight: 600;
  color: #323130; // black
`;

export const ApprovedStatus = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 130px;
  height: 24px;
  left: calc(50% - 130px / 2 + 667.73px);
  top: calc(50% - 24px / 2 - 192px);
  border-radius: 2px;
  background: #caefc1; // green
  font-size: 12px;
  font-weight: 600;
  color: #323130; // black
`;

export const ProvisionedStatus = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 130px;
  height: 24px;
  left: calc(50% - 130px / 2 + 667.73px);
  top: calc(50% - 24px / 2 - 192px);
  border-radius: 2px;
  background: #caefc1; // green
  font-size: 12px;
  font-weight: 600;
  color: #323130; // black
`;

export const ConsumerName = styled(Text)`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #0078d4;
  cursor: pointer;
`;

export const DataOwnerName = styled(Text)`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #0078d4;
`;

export const ErrorContainer = styled.div`
  margin:20px 80px 20px 100px;
`;

